
import { computed, inject, onUnmounted, ref, shallowRef, watch } from '@vue/composition-api';
import { defineComponent, useMeta, useRoute, useRouter } from '@nuxtjs/composition-api';
import { Button, Modal, StatusBlock } from '05-ui-kit';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import { declination } from '@artmizu/utils';
import { stringify } from 'qs';
import TSProductGrid from '~/components/ts-components/TSProductGrid/TSProductGrid.vue';
import type { EmitteryType } from '~/plugins/emitter';
import type { Product } from '~/type/product/Product';
import ActionFavorite from '~/action/ActionFavorite.vue';
import DataEntityList from '~/data/DataEntityList/DataEntityList.vue';
import Unavailable from '~/components/Unavailable/Unavailable.vue';
import { useUserStore } from '~/store/user';
import { useUserListStore } from '~/store/userLists';
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.setup = (__props, __ctx) => {
  const emitter = inject<EmitteryType>('emitter')!;
  const route = useRoute();
  const router = useRouter();
  const userStore = useUserStore();
  const params = ref<{
    sort: string;
    size?: number;
    page?: number;
    id?: string;
  }>({
    sort: '',
    ...route.value.query,
    page: Number(route.value.query.PAGEN_1)
  });
  const initialLoad = ref(true);
  const modalActive = ref(false);
  const productList = ref<Product[]>([]);
  const products = shallowRef<HTMLDivElement>();
  const userList = useUserListStore();
  const query = computed(() => {
    return route.value.query;
  });
  const linkPage = computed(() => {
    const query = {
      ...route.value.query
    };
    if (query.PAGEN_1) delete query.PAGEN_1;
    const queryLength = Object.keys(query)?.length || 0;
    return queryLength ? `${route.value.path}?${stringify(query)}&` : `${route.value.path}?`;
  });
  const ids = computed(() => {
    return productList.value?.map(el => el.id).join(',') || null;
  });
  const favoriteIds = computed(() => userList.favoriteIds);
  const declOfNumGoods = computed(() => {
    return `${productList.value.length} ${declination(productList.value.length, ['модель', 'модели', 'моделей'])}`;
  });
  useMeta(() => ({
    title: 'Избранные товары'
  }));
  watch(() => query.value, () => {
    params.value = {
      sort: 'new',
      ...route.value.query,
      page: Number(route.value.query.PAGEN_1),
      id: (route.value.params.id as string)
    };
  });
  const userListMutation = userList.$onAction(mutation => {
    if (mutation.name === 'remove' && mutation.args[0].type === 'favorite') productList.value = productList?.value?.filter(el => el.id !== mutation.args[0].id);
  });
  const userMutation = userStore.$onAction(mutation => {
    if (mutation.name === 'setData' || mutation.name === 'logout') initialLoad.value = true;
  });
  onUnmounted(() => {
    if (userListMutation) userListMutation();else if (userMutation) userMutation();
  });
  function onSuccess({
    list
  }: {
    list: Product[];
  }) {
    productList.value = list;
    initialLoad.value = false;
    if (process.client && productList.value?.length) emitter.emit('product-list-view', {
      list: productList.value,
      listName: 'Избранные товары'
    });
  }
  function onRemoveFavorite(val: number, list: Product[]) {
    const index = list.findIndex(item => item.id === val);
    if (index !== -1) list.splice(index, 1);
  }
  function onSort({
    value
  }: {
    value: string;
  }) {
    router.push({
      query: {
        ...route.value.query,
        sort: value
      }
    });
  }
  function changeQueryParamsPage(num?: number) {
    const query = {
      ...params.value,
      PAGEN_1: num
    };
    /**
    * чтобы при нажатии на первую страницу, не пушить параметр страницы
    */
    if (query.PAGEN_1 === 1) delete query.PAGEN_1;
    if (query.page) delete query.page;
    router.push({
      query: {
        ...route.value.query,
        PAGEN_1: query.PAGEN_1?.toString()
      }
    });
  }
  function scrollTop() {
    if (products.value) {
      scrollIntoView(products.value, {
        block: 'start'
      });
    }
  }
  return {
    emitter,
    params,
    initialLoad,
    modalActive,
    productList,
    products,
    userList,
    linkPage,
    ids,
    favoriteIds,
    declOfNumGoods,
    onSuccess,
    onRemoveFavorite,
    onSort,
    changeQueryParamsPage,
    scrollTop
  };
};
__sfc_main.components = Object.assign({
  DataEntityList,
  StatusBlock,
  TSProductGrid,
  ActionFavorite,
  Modal,
  Button,
  Unavailable
}, __sfc_main.components);
export default __sfc_main;
